"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PRODUCT_BOX_SHADE_TEST_ID = exports.MAX_VISIBLE_SHADES_COUNT = void 0;
const MAX_VISIBLE_SHADES_COUNT = exports.MAX_VISIBLE_SHADES_COUNT = 6;
const PRODUCT_BOX_SHADE_TEST_ID = exports.PRODUCT_BOX_SHADE_TEST_ID = 'product-box-shade';
